(function(){
    class DistanceRule extends SlotsEngine.instantiators.SymbolRule{
        constructor(){
            super();
        }

        initialise(json){
            let groupings = {};
            for (let i = 0; i < json.rules.length; ++i){
                groupings = Object.assign(groupings,json.rules[i]);
            }
            super.initialise(groupings);
        }

        isSymbolValid(symbolId, previousWindowSymbols){ // REVERSE (maybe)
            if (!this.doesSymbolHaveRule(symbolId))
                return true;
            
            let distanceNeeded = this.getNumSymbolsNeeded(symbolId);
            let symbolsWithinDistance = previousWindowSymbols.slice( previousWindowSymbols.length - distanceNeeded, previousWindowSymbols.length );
            let symbolsToDistanceFrom = this._rules[""+symbolId].symbolsToDistanceFrom;
        
            let filteredArray = symbolsWithinDistance.filter(function(n) {
                return symbolsToDistanceFrom.indexOf(n) !== -1;
            });

            return filteredArray.length === 0;
        }

        getReservedSymbols(symbol, num){
            console.log("ERROR Should never be calling getReservedSymbols on distance rules");
            return [];
        }

        getNumSymbolsToReserve(){
            return 1;
        }

        testReelBandPassesRule(reelBand){
            for (let prop in this._rules){
                if (this._rules.hasOwnProperty(prop)){
                    let symId = Number(prop);
                    let distanceNeeded = this._rules[prop].count;
                    for (let i = 0; i < reelBand.length; ++i){                        
                        if (reelBand[i] === symId){
                            let symbolsToDistanceFrom = this._rules[""+symId].symbolsToDistanceFrom;           
                            let symbolsWithinDistance = [];
                            for (let j = 1; j <= distanceNeeded; ++j){
                                symbolsWithinDistance.push( reelBand[(i+j)%reelBand.length]);
                            }
                            let filteredArray = symbolsWithinDistance.filter(function(n) {
                                return symbolsToDistanceFrom.indexOf(n) !== -1;
                            });                            
                            if (filteredArray.length > 0)
                                return false;
            
                        }
                    }
                }
            }
            return true;
        }
    }
    resourceManager.registerController("SymbolRules_distance", function(){
        return new DistanceRule();
    });
})();